import * as React from 'react';

import { Hero } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';

export const LandingHeroBlockContainer: React.FC = () => {
    const [animation, setAnimation] = React.useState<'in' | 'out'>('in');

    React.useEffect(() => {
        console.log('animation is ', animation);
        const handleScroll = (event: Event) => {
            const target = event.target as Document;
            const scrollY = target.scrollingElement?.scrollTop || 0;
            if (scrollY > 50 && animation === 'in') {
                setAnimation('out');
            } else if (scrollY === 0 && animation === 'out') {
                setAnimation('in');
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [animation]);

    return (
        <Hero
            animationCards={[
                {
                    imgSrc: '/assets/animation-card-1.jpg',
                    altText: lexemes.lxPageIndexHeroCard1Alt,
                    text: 'Danna, 28',
                },
                {
                    imgSrc: '/assets/animation-card-2.jpg',
                    altText: lexemes.lxPageIndexHeroCard2Alt,
                    text: 'Josh, 34',
                },
                {
                    imgSrc: '/assets/animation-card-3.jpg',
                    altText: lexemes.lxPageIndexHeroCard3Alt,
                    text: 'Tiana, 30',
                },
            ]}
            animation={animation}
        />
    );
};
